import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/hotelschool-the-hague/narrowcasting/app/layouts/default.vue").then(m => m.default || m)),
  overview: defineAsyncComponent(() => import("/builds/hotelschool-the-hague/narrowcasting/app/layouts/overview.vue").then(m => m.default || m))
}